import { useState, useEffect, useRef } from 'react';

/**
 * Anima um número de 0 até `valorFinal` via requestAnimationFrame.
 * Reinicia sempre que `valorFinal` muda (ex: perfil recarregado com um
 * total maior).
 */
export function useCountUp(valorFinal: number, duracaoMs = 900): number {
  const [valor, setValor] = useState(0);
  const frameRef = useRef<number | null>(null);

  useEffect(() => {
    const inicioMs = performance.now();

    const tick = (agoraMs: number) => {
      const progresso = Math.min(1, (agoraMs - inicioMs) / duracaoMs);
      setValor(Math.round(valorFinal * progresso));
      if (progresso < 1) {
        frameRef.current = requestAnimationFrame(tick);
      }
    };

    frameRef.current = requestAnimationFrame(tick);
    return () => {
      if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
    };
  }, [valorFinal, duracaoMs]);

  return valor;
}
